export const siteSettings = {
  name: "FX Market Elite Pros",
  link: "https://fxmarketpros.com",
  email: "support@fxmarketpros.com",
  appLink: "https://app.fxmarketpros.com",
};
